import { render } from "./ListPagination.vue?vue&type=template&id=2e0812b8&ts=true"
import script from "./ListPagination.vue?vue&type=script&lang=ts"
export * from "./ListPagination.vue?vue&type=script&lang=ts"

import "./ListPagination.vue?vue&type=style&index=0&id=2e0812b8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__